import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import FormWrapper from "src/components/FormWrapper";
import { FormProvider } from "src/components/hook-form";
import RHFAutocomplete from "src/components/hook-form/RHFAutocomplete";
import { deliveryAdd, getAllRider } from "src/pages/api";
import * as Yup from "yup";

const defaultValues = {
  riderID: "",
};
const schema = Yup.object().shape({
  riderID: Yup.object()
    .shape()
    .typeError("Required")
    .nullable()
    .required("Required"),
});
export default function AddRider({ onClose, row }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetched } = useQuery({
    queryKey: ["getAllRider"],
    queryFn: getAllRider,
  });
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });
  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const mutation = useMutation(req => deliveryAdd({ req }), {
    onSuccess: () => {
      enqueueSnackbar(`Delivery Assigned Successfully`, {
        variant: "success",
      });
      queryClient.invalidateQueries(["getAllDeliveryOrder"]);
      onClose();
    },
    onError: error => {
      enqueueSnackbar(error?.message || "Failed to Assign", {
        variant: "error",
      });
    },
  });
  const onSubmit = data => {
    const req = {
      orderID: row.orderID,
      riderID: data.riderID.id,
      // deliveryCompanyID: "string",
    };

    mutation.mutate(req);
    return;
  };

  useEffect(() => {
    const resetField = async () => {
      reset({
        riderID: data?.find(el => el.id === row?.rider_id),
      });
    };
    if (row) {
      resetField();
    }
  }, [row, isFetched]);
  // console.log(errors, "errors");
  return (
    <FormWrapper
      onClose={onClose}
      onSubmit={handleSubmit(onSubmit)}
      onReset={() => {
        reset();
      }}
      loading={mutation.isLoading || isLoading}
      maxWidth={"xs"}
      fullWidth
      title={"Assign Rider"}
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <RHFAutocomplete
              name={"riderID"}
              size="small"
              label="Select Rider *"
              loading={isLoading}
              option={data || []}
              getOptionLabel={option => option.fullName}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </FormWrapper>
  );
}
